import { cn } from '@/lib/utils'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-clay-200 dark:bg-clay-600', className)}
      {...props}
    />
  )
}

export { Skeleton }
